import React from 'react';
import { Link } from 'react-router-dom';
import {RETURN_SVG,CLOSE_REWARD_SVG} from '../staticTypes'

const Header = (props) => {
	const { points, onClick, launcherFlag, link } = props;
	const closeReward = () => {
		onClick(!launcherFlag)
	}
	return (
		<div className="panel-header-container expanded-header compact-banner collapsed has-close-btn" tabIndex="-1">
			<div className="panel-expanded-header background-gradient">
				<div className="banner-content">
					<Link to={link}>
						<div className="header-icon return-home">
							{RETURN_SVG}
						</div>
					</Link>
					<div className="header-secondary child-header-secondary heading text-truncate" style={{ margin: '0px' }}>
						{points >= 0 ? points + ' points' : 'wantdo'}
					</div>
					<button className="close-btn panel-header-icon" aria-label="Close" onClick={closeReward}>
					{CLOSE_REWARD_SVG}
					</button>
				</div>
			</div>
		</div>
	);
}

export default Header;